import React, { useState } from "react";
import {
  Dimensions,
  FlatList,
  Image,
  Modal,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";

// import { useTranslation } from "react-i18next";
import AppFonts from "../../../Constants/AppFonts";
import AppColors from "../../../Constants/AppColors";
import AppImages from "../../../Constants/AppImages";
import { PaymentBill } from "../../../Constants/Data";
import Appstyles from "../../../Constants/AppStyles";

const { width, height } = Dimensions.get("window");

const PaymentInvoice = ({ navigation }) => {
  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };

  // render
  return (
    <SafeAreaView style={Appstyles.safe}>
      <View style={Appstyles.HeaderMain}>
        <View style={Appstyles.HeaderSec}>
          <TouchableOpacity
            style={Appstyles.Arrowstyle}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image source={AppImages.Backbtn} style={Appstyles.ArrowImage} />
          </TouchableOpacity>
          <Text style={Appstyles.HeaderText}>
            {t("common:translation.Invoice")}
          </Text>
        </View>
        <View style={Appstyles.rc}>
          <Image
            source={AppImages.VechicleNoti}
            style={Appstyles.VehicleImage}
            resizeMode="contain"
          />

          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={Appstyles.BellImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>

      <View style={Appstyles.paymentdfgdf7}>
        <View style={Appstyles.MarginHor207}>
          <View style={Appstyles.jsma7}>
            <View style={Appstyles.Searchvi6}>
              <TextInput
                style={Appstyles.TextInput7}
                placeholder="Search Invoice Number, Date, Amount...."
                placeholderTextColor={"#AAAAAA"}
                editable={true}
                autoCapitalize="none"
              />

              <View style={Appstyles.paydas7}>
                <Image
                  source={AppImages.search}
                  style={Appstyles.SearchImage}
                />
              </View>
            </View>

            <Image
              source={AppImages.Import}
              style={Appstyles.ImpoShare7}
              resizeMode="contain"
            />

            <Image
              source={AppImages.Shareit}
              style={Appstyles.ImpoShare7}
              resizeMode="contain"
            />
          </View>
        </View>

        <FlatList
          showsVerticalScrollIndicator={false}
          ListFooterComponent={() => <View style={{ padding: 65 }} />}
          data={PaymentBill}
          renderItem={({ item }) => (
            <TouchableOpacity
              onPress={() => navigation.navigate("InvoiceDetail")}
              style={Appstyles.MarginHor207}
            >
              <View style={Appstyles.FlatmainPayment7}>
                <View style={Appstyles.FlatmainSecPay7}>
                  <View style={styles.FlatImg}>
                    <View style={Appstyles.flexDirection}>
                      <Image
                        source={item.img}
                        style={Appstyles.imginovicePay7}
                        resizeMode="contain"
                      />
                      <View style={Appstyles.FlatTxtPayy7}>
                        <Text style={Appstyles.FlatTxtSeccc7}>
                          Invoice Number
                        </Text>
                        <Text style={Appstyles.CopyTextSess7}>{item.T2}</Text>
                      </View>
                    </View>
                  </View>
                </View>
                <View>
                  <View style={Appstyles.lineeedss7}></View>
                </View>
                <View style={Appstyles.fllmmpay7}>
                  <TouchableOpacity style={{}}>
                    <View style={Appstyles.mmargin7}>
                      <View style={styles.Row}>
                        <Text style={Appstyles.Texttp7}>Invoice Date</Text>
                      </View>
                      <View style={styles.Row}>
                        <Text style={Appstyles.CopyTextSecd7}>{item.H1}</Text>
                      </View>
                      <View style={styles.Row}>
                        <Text style={Appstyles.Texttp7}>Due Date</Text>
                      </View>
                      <View style={styles.Row}>
                        <Text style={Appstyles.CopyTextSecd7}>{item.H3}</Text>
                      </View>
                      <View style={styles.Row}>
                        <Text style={Appstyles.Texttp7}>Invoice Amount</Text>
                      </View>
                      <View style={styles.Row}>
                        <Text style={Appstyles.CopyTextSecd7}>{item.H5}</Text>
                      </View>
                    </View>
                  </TouchableOpacity>
                  <View style={Appstyles.imagepay7}>
                    <Image source={item.img2} style={Appstyles.invoicepay7} />
                  </View>
                </View>
              </View>
            </TouchableOpacity>
          )}
        />
      </View>
    </SafeAreaView>
  );
};

export default PaymentInvoice;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.sandal },
  img: { width: 20, height: 20 },
  imgg: { width: 16, height: 20, marginLeft: 20 },
  simp: {
    justifyContent: "center",
  },
  Txtxt: {
    alignItems: "center",
    justifyContent: "center",
    fontFamily: AppFonts.OverpassBold,
    fontWeight: "600",
    fontSize: 18,
    color: AppColors.brown1,
  },
  Viewwd: {
    backgroundColor: AppColors.sandal,
    width: "100%",
    padding: 20,
    borderBottomLeftRadius: 15,
    borderBottomWidth: 1.5,
    borderBottomRightRadius: 15,
    borderBottomColor: AppColors.brown,
  },
  HeaderMain: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: AppColors.white,
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: AppColors.brown,

    shadowOffset: { width: 10, height: 10 },
    shadowOpacity: 10,
    shadowRadius: 10,
    elevation: 20,
  },
  HeaderSec: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  HeaderBackTouch: { height: 30, width: 30, justifyContent: "center" },
  HeaderBackImage: { width: 8, height: 15 },
  HeadTextVechicle: {
    color: "#8F4300",
    fontFamily: AppFonts.OverpassMedium,
    fontSize: 16,
  },
  ImagesView: {
    flexDirection: "row",
    alignItems: "center",
  },
  TExtinputView: {
    marginTop: 10,
    borderRadius: 10,
    height: height * 0.07,
    backgroundColor: AppColors.sandal,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,

    borderRadius: 10,
    borderColor: AppColors.sandal,
    height: height * 0.07,
    borderWidth: 1,
  },
  container: {
    flex: 1,
    justifyContent: "center",
    paddingBottom: 20,
  },
  listContainer: {
    marginTop: 20,
    borderRadius: 10,
    alignItems: "center",
    flexDirection: "row",
  },
  TextList: {
    marginLeft: 10,
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassBold,
  },

  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 20,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 45,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  //-------------
  Touch: { justifyContent: "center", alignItems: "center" },
  Txtst: {
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassBold,
    fontSize: 18,
    fontWeight: "700",
  },

  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "30%",
    marginHorizontal: 20,
  },
  //---------
  fle: {
    flex: 1,
  },

  mar: { marginHorizontal: 20 },

  SecMain: { marginHorizontal: 20 },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    width: "100%",
    paddingVertical: 10,
    // height: height * 0.04,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "80%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    // height: height * 0.05,
    borderWidth: 1,
    paddingLeft: 20,
    flexDirection: "row",

    borderRadius: 8,
    justifyContent: "space-between",

    shadowColor: "#000001A",
    shadowOffset: { width: 1, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    // elevation: 6,
  },
  ExImport: { flexDirection: "row", marginHorizontal: 10 },
  Flatmain: {
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    // margin: 10,
    marginLeft: 10,
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatTxt: { justifyContent: "center", marginLeft: 20 },
  FlatTxtSec: {
    fontSize: 12,

    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
  },
  tabe: { width: 155 },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  //   LineBars: {
  //     width: '180%',
  //     right: 20,
  //     // position: 'absolute',
  //     borderTopColor: AppColors.brown,
  //     borderTopWidth: 0.7,
  //     opacity: 0.099,
  //     marginTop: 10,
  //   },
  CopyText: {
    fontSize: 14,
    marginTop: 3,

    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    width: "100%",
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSe: {
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  NonCopy: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 3,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  // Row: { flexDirection: "row" },

  TextTwo: {
    fontSize: 12,
    marginTop: 3,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  //--------modal Del
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    marginHorizontal: 10,
  },
  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 10,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 35,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  lins: {
    borderTopWidth: 1,
    width: "100%",
    // right: 20,
    borderTopColor: AppColors.sandal,
    marginTop: 20,
  },
  vee: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  im: { width: 20, height: 20, marginRight: 30 },
  too: { alignSelf: "flex-end", justifyContent: "center" },
  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22, marginLeft: 10 },
  iamge: { width: 22, height: 22, alignItems: "center" },
  feed: { backgroundColor: AppColors.FeedBack, flex: 1, opacity: 0.55 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center" },
  jns: { width: "15%", height: 2 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.dualbrown,
  },
  ttxt1: {
    fontFamily: AppFonts.OverpassSemiBold,

    fontSize: 16,
    color: AppColors.brown1,
  },
  fffsf: {
    marginTop: 20,
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.dualbrown,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.BLUR_BG,
    alignItems: "center",
    justifyContent: "center",
  },
  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    alignItems: "center",
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 12, height: 12, alignItems: "center" },
  fasfd: { marginTop: 20, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 20,
  },
  toda: { marginTop: 20, flexDirection: "row" },
  Searchstyle: {
    flex: 1,
    backgroundColor: "white",
    width: "100%",
    // marginTop: 20

    // flexGrow: 30,
  },
  tab: { backgroundColor: AppColors.brown },
});
